import { render } from "./ServiceMultiSelect.vue?vue&type=template&id=55c7dbb2&scoped=true"
import script from "./ServiceMultiSelect.vue?vue&type=script&lang=js"
export * from "./ServiceMultiSelect.vue?vue&type=script&lang=js"

import "./ServiceMultiSelect.vue?vue&type=style&index=0&id=55c7dbb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c7dbb2"]])

export default __exports__